<template>
    <div class="also-viewed" v-if="CustomerView">
        <div class="pro-viewed-list">
                                <h4 class="border-bottom border-1 pb-2 mb-4">Customers Also Viewed</h4>
                                <div class="row row-cols-2 row-cols-md-6 row-cols-lg-6 row-cols-xl-6 gx-2">
                                    <div class="col" v-for="item  in CustomerView" :key="item.id">
                                        <div class="product-card border-0">
                                            <div class="card-body">
                                                <div class="pro-img-block">
                                                    <div v-lazy-container="{ selector: 'img' }">

                                                        <img :data-src="set_image(item.product.photo)" class="card-img-top pro-img"
                                                             :alt="item.product.name" data-error="assets/images/no_image.svg" data-loading="assets/images/loading.gif">
                                                    </div>


                                                </div>
                                                <div class="pro-short-desc pro-link fw-medium" v-html="item.product.name"></div>
                                                <div class="font-14 mb-1">Brand: <span>{{ item.product.description }}</span></div>
                                                <h6 class="pro-price"> 
                                                    {{
                                CalculateProductSellPrice(item.price, item.discount, item.product_admin_markup_amount, item.contractor_products[0].markup, item.box_sqft, (item.product && item.product.category && item.product.category.unit) ? item.product && item.product.category && item.product.category.unit : '')|toCurrency
                            }}
                                                
                                                </h6>
<!--                                                <div class="star-rated">-->
<!--                                                    <span class="star-rating" style="width: 04.3034em;"></span>-->
<!--                                                </div>-->
                                            </div>

                                                <router-link :to="`/product/${str_encode(item.id)}`"  class="stretched-link"></router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
        </div>
    </div>

</template>

<script>
export default {
    props:['CustomerView'],

    methods:{
        CalculateProductSellPrice(Price, Discount, ProductAdminMarkupAmount, ContractorMarkup, box_sqft = 0, unit = '') {
            Price = parseFloat(Price);
            Discount = parseFloat(Discount);
            ProductAdminMarkupAmount = parseFloat(ProductAdminMarkupAmount);
            ContractorMarkup = parseFloat(ContractorMarkup);
            let product_price = (Price - (Price * Discount / 100)) + ProductAdminMarkupAmount;
            let contractor_markup = product_price * ContractorMarkup / 100;
            //let admin_markup = ProductAdminMarkupAmount
            let sell_price = product_price + contractor_markup;
            //return sell_price.toFixed(2);

            return unit == 'Box' ? (sell_price / box_sqft) : sell_price;
        },
    }
}
</script>
